module.exports = __webpack_public_path__ + "img/pick5.3f9f4676.png";